// Bootstrap
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Link } from "react-router-dom";
import ListGroup from 'react-bootstrap/ListGroup';
// Libs
import { TwitterShareButton } from 'react-twitter-embed';

const Home = () => {
  return (
    <>
      <Row className="justify-content-md-center text-center" style={{marginTop: "48px"}}>
        <small>0xfire is a venture studio founded by <a target="_blank" href="https://twitter.com/0xconstantin">0xconstantin</a>.</small>
      </Row>
      <Row className="justify-content-md-center text-center" style={{marginTop: "48px"}}></Row>
    </>
  );
};

export default Home;
